// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"462":"7f1678be","492":"0d29eb66","754":"ad9429ef"}[chunkId] + ".css";
};